import React from "react";
import { Loader2 } from "lucide-react";

export default function PageLoader({ text = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-stone-400">
      <Loader2 className="animate-spin" size={28} />
      <p className="text-sm">{text}</p>
    </div>
  );
}
